import qs from 'qs';
import axios from 'axios';
import md5 from 'blueimp-md5';
import long from 'long';
import store from 'common/services/storage';
import loading from 'components/mtLoading/mtLoading';
import modal from 'components/mtModal/mtModal';
import conf from '../config';
import utils from '../utils';
import constants from '../constants';
import TOKEN from './token';

function getMTRequest() {
  const req = axios.create({
    timeout: conf.TIME_OUT,
    // request之前数据处理，也可以修改header,只适用于 put post patch ，
    // 数组最后一个函数必须返回 String,Buffer,ArrayBuffer,FormData或者Stream
    // transformRequest : [function (data, headers) {
    //   return data;
    // }],
    // transformResponse: [function (data) {
    //   return data;
    // }],
    // 此处很奇怪呀：加入'X-Requested-With': 'XMLHttpRequest',或者整个headers不写会导致增加一个options请求，跨域失败
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'json',
  });
  req.interceptors.request.use(
    (config) => {
      aesRequest(config);
      if (config.mtOptions.shouldBeJSONContentType) {
        delete config.headers['Content-Type'];
      }
      const loginUid = store.get(store.LOGIN_ENCRYPTED_UID);
      if (!utils.isEmpty(loginUid)) {
        config.headers['MT-AUTH'] = loginUid;
      }
      const reqQueryObject = config.params || {}; // query string params
      // const reqBodyObject = qs.parse(config.data); // request body params
      // for common params, use request body params override query string params and storage value
      // when it comes a post method
      const token = store.get('MT_TOKEN');
      reqQueryObject.token = token;
      config.params = reqQueryObject;
      return config;
    }, (error) => {
      return Promise.reject(error);
    },
  );
  // response拦截器,全局设置
  /* eslint-disable */
  req.interceptors.response.use((res) => {
    const errCode = constants.errCode;
    if (res.status >= 200 && res.status < 300) {
      if (res.status === 200) {
        // 约定请求异常的code
        switch (res.data.errorCode) {
          case errCode.userNotExist:
            // 用户不存在
            // TODO:
            break;
          case errCode.invalidUser:
            // confirm.pop('非法请求用户，请重新登陆', {
            //   buttons: [{ text: '确定' }],
            // }).then(() => {
            //   // action.logout('/userLogin');
            // });
            break;
          case errCode.invalidToken:
            const renewTokenPromise = TOKEN.renewToken();
            return renewTokenPromise.then((token) => {
              const replayConfig = req.defaults.mtReplayConfig;
              return new Promise((resolve, reject) => {
                const replayOption = Object.assign({}, replayConfig.mtOptions);
                replayOption.replaying = true;
                ajax(replayConfig.uri, replayConfig.params, replayConfig.type, replayOption)
                  .then((replayRes) => {
                    resolve(replayRes);
                  }, (err) => {
                    reject(err);
                  })
              })
            })
          default:
        }
      }
      return res;
    }
    // 由后端抛出的错误
    if (!res.config.mtOptions.silent) {
      modal.pop('服务器连接异常');
    }
    return Promise.reject(res);
  }, (error) => {
    if (axios.isCancel(error)) {
      return null;
    }
    // 由网络或者服务抛出的错误
    if (!error.config.mtOptions.silent) {
      modal.pop('服务器连接异常');
    }
    return Promise.reject(error);
  });

  return req;
}

function ajax(uri, params = {}, type = 'get', mtOptions = {}) {
  const req = getMTRequest();
  req.defaults.originUri = uri;
  req.defaults.mtOptions = mtOptions;
  req.defaults.mtReplayConfig = {
    uri,
    params,
    type,
    mtOptions,
  };

  if (mtOptions.loading) {
    loading.spin();
  }
  params.mttimestamp = new Date().getTime();
  if (type === 'post' && !mtOptions.shouldBeJSONContentType && !(params instanceof FormData)) {
    params = qs.stringify(params, { arrayFormat: 'repeat' });
  }
  const p = new Promise((resolve, reject) => {
    req({
      method: type,
      url: `${process.env.NODE_ENV === 'production' ? conf.BASE_URI : conf.BASE_URI_TEST}${uri}`,
      params: type === 'get' ? params : {},
      data: type === 'post' ? params : {},
      paramsSerializer(input) {
        return qs.stringify(input, { arrayFormat: 'repeat' });
      },
    }).then((res) => {
      console.log(res);
      // replay should resolve immediately
      if (mtOptions.replaying) {
        resolve(res);
        return;
      }
      if (mtOptions.loading) {
        loading.stop();
      }
      if (!res.data.status && !mtOptions.raw && !mtOptions.silent) {
        modal.pop(res.data.error);
        return;
      }
      if (mtOptions.raw) {
        resolve(res.data);
      } else {
        resolve(res.data.data);
      }
    }, (err) => {
      // replay should reject immediately
      if (mtOptions.replaying) {
        reject(err);
        return;
      }

      if (mtOptions.loading) {
        loading.stop();
      }
      if (!mtOptions.silent) {
        console.log(err);
      }
      reject(err);
    }).catch((thrown) => {
      if (axios.isCancel(thrown)) {
        console.log('cancelled');
      }
    });
  });
  return p;
}

/**
 * options包含一些额外的参数：
   shouldBeJSONContentType: Boolean,设置request的content-type为 text/json, 适应后端某些接口
   raw                    : Boolean,获取完整的返回值，包含erro_msg和error_code,默认false
   loading                : Boolean,是否显示loading图标，默认不显示
   silent                 : Boolean,是否在请求服务器失败时出现提示
   handleUserNotFound     : Boolean,是否自动处理用户不存在的error code
 */
function get(uri, params = {}, options = {}) {
  return ajax(uri, params, 'get', options);
}
function post(uri, params = {}, options = {}) {
  return ajax(uri, params, 'post', options);
}
function all() {
}
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
function aesRequest(config) {
  const timestamp = new Date().getTime();
  const random6Str = genRandomStr();
  const combinedStr = long.fromString(`2018${timestamp}`, 10).shiftRight(4).toString(10);
  const raw = `maitao${config.originUri}${random6Str}${combinedStr}`;
  try {
    const cooked = md5(raw).toUpperCase().slice(8, 24);
    config.headers.Sign = cooked;
    config.headers.MTTimestamp = timestamp;
    config.headers.Random = random6Str;
  } catch (e) {
    console.log(e);
  }
}
function genRandomStr() {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < 6;) {
    const index = Math.floor(Math.random() * possible.length);
    text += possible.charAt(index);
    i += 1;
  }
  return text;
}
export default {
  get,
  post,
  all,
  aesRequest,
};
